export default {
  guests_pay: 'Gäste zahlen an der Kasse {{amount}} (aktueller Wechselkurs).',
  missing_rate: 'Noch kein Wechselkurs für {{currency}} – Gäste zahlen daher unumgerechnet {{amount}}.',
};
